// src/app/pages/customization/customization.validation.ts
import { Selections, Shirt, Short, Socks } from 'src/app/model/out-fit';

const MSG = {
  // ---- shirt ----
  'SHIRT.COLLAR_COLOR_REQUIRED': 'CUSTOMIZATION.VALIDATION.COLLAR_COLOR_REQUIRED',
  'SHIRT.SHOULDER_COLOR_REQUIRED': 'CUSTOMIZATION.VALIDATION.SHOULDER_COLOR_REQUIRED',
  'SHIRT.BODY_COLOR_REQUIRED': 'CUSTOMIZATION.VALIDATION.BODY_COLOR_REQUIRED',
  'SHIRT.SLEEVE_COLOR_REQUIRED': 'CUSTOMIZATION.VALIDATION.SLEEVE_COLOR_REQUIRED',
  'SHIRT.LOGO_COLOR_REQUIRED': 'CUSTOMIZATION.VALIDATION.LOGO_COLOR_REQUIRED',
  'SHIRT.SHOULDER_LOGO_COLOR_REQUIRED': 'CUSTOMIZATION.VALIDATION.SHOULDER_LOGO_COLOR_REQUIRED',

  // ---- short ----
  'SHORT.COLOR_REQUIRED': 'CUSTOMIZATION.VALIDATION.SHORT_COLOR_REQUIRED',
  'SHORT.LOGO_COLOR_REQUIRED': 'CUSTOMIZATION.VALIDATION.SHORT_LOGO_COLOR_REQUIRED',

  // ---- socks ----
  'SOCKS.TOP_COLOR_REQUIRED': 'CUSTOMIZATION.VALIDATION.SOCKS_TOP_COLOR_REQUIRED',
  'SOCKS.LOGO_COLOR_REQUIRED': 'CUSTOMIZATION.VALIDATION.SOCKS_LOGO_COLOR_REQUIRED',
  'SOCKS.BOTTOM_COLOR_REQUIRED': 'CUSTOMIZATION.VALIDATION.SOCKS_BOTTOM_COLOR_REQUIRED',

  // ---- materials (NEW) ----
  'MATERIAL.PART_FABRIC_REQUIRED': 'CUSTOMIZATION.VALIDATION.MATERIAL_PART_FABRIC_REQUIRED',
  'MATERIAL.PART_MATERIAL_REQUIRED': 'CUSTOMIZATION.VALIDATION.MATERIAL_PART_MATERIAL_REQUIRED',
} as const;

export type ValidationErrorKey = keyof typeof MSG;

export type ValidationResult = {
  valid: boolean;
  errorKeys: ValidationErrorKey[];
  errors: string[];
};

const hasValue = (v?: string | null) =>
  typeof v === 'string' && v.trim().length > 0;

/** Validate only the shirt step */
export function validateShirt(shirt: Shirt): ValidationResult {
  const errorKeys: ValidationErrorKey[] = [];

  if (!hasValue(shirt?.collarColor))         errorKeys.push('SHIRT.COLLAR_COLOR_REQUIRED');
  if (!hasValue(shirt?.shoulderColor))       errorKeys.push('SHIRT.SHOULDER_COLOR_REQUIRED');
  if (!hasValue(shirt?.bodyColor))           errorKeys.push('SHIRT.BODY_COLOR_REQUIRED');
  if (!hasValue(shirt?.sleeveColor))         errorKeys.push('SHIRT.SLEEVE_COLOR_REQUIRED');
  if (!hasValue(shirt?.logoColor))           errorKeys.push('SHIRT.LOGO_COLOR_REQUIRED');
  if (!hasValue(shirt?.shoulderLogoColor))   errorKeys.push('SHIRT.SHOULDER_LOGO_COLOR_REQUIRED');

  return {
    valid: errorKeys.length === 0,
    errorKeys,
    errors: errorKeys.map(k => MSG[k]),
  };
}

/** Validate only the short step */
export function validateShort(short: Short): ValidationResult {
  const errorKeys: ValidationErrorKey[] = [];

  if (!hasValue(short?.color))     errorKeys.push('SHORT.COLOR_REQUIRED');
  if (!hasValue(short?.logoColor)) errorKeys.push('SHORT.LOGO_COLOR_REQUIRED');

  return {
    valid: errorKeys.length === 0,
    errorKeys,
    errors: errorKeys.map(k => MSG[k]),
  };
}

/** Validate only the socks step */
 
/** Validate everything needed before final submit/share */
export function validateBeforeSubmit(sel: Selections): ValidationResult {
  // Keep simple: rely on step-level checks; do a final shirt check for safety
  return validateShirt(sel.shirt);
}

/** NEW: Require a fabric type & a material for every part */
export function validateMaterials(parts: Array<{ selectedFabricType?: string; selectedMaterial?: any }>): ValidationResult {
  const errorKeys: ValidationErrorKey[] = [];
  let missingFabric = false;
  let missingMaterial = false;

  for (const p of parts || []) {
    if (!p?.selectedFabricType) missingFabric = true;
    if (!p?.selectedMaterial)   missingMaterial = true;
  }

  if (missingFabric)   errorKeys.push('MATERIAL.PART_FABRIC_REQUIRED');
  if (missingMaterial) errorKeys.push('MATERIAL.PART_MATERIAL_REQUIRED');

  return {
    valid: errorKeys.length === 0,
    errorKeys,
    errors: errorKeys.map(k => MSG[k]),
  };
}


/** Validate only the socks step */
export function validateSocks(socks: Socks): ValidationResult {
  const errorKeys: ValidationErrorKey[] = [];

  if (!hasValue(socks?.topColor))    errorKeys.push('SOCKS.TOP_COLOR_REQUIRED');
  if (!hasValue(socks?.logoColor))   errorKeys.push('SOCKS.LOGO_COLOR_REQUIRED');
  if (!hasValue(socks?.bottomColor)) errorKeys.push('SOCKS.BOTTOM_COLOR_REQUIRED');

  return {
    valid: errorKeys.length === 0,
    errorKeys,
    errors: errorKeys.map(k => MSG[k]),
  };
}
